import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import {emitter} from '../../../base/utils/emitter'
import { ICashback } from '../../../daneshfx-interfaces/cashback'
import services from '../../../services'

export const CashbackItem = (cashback: ICashback) => {
    console.log({ cashback })
    const at = Div(new Date(cashback.at).toLocaleString())
    const email = Div(cashback.email)
    const amount = Div('مبلغ:  <b>' + cashback.amount + '</b>دلار کانادا')
    const phone = Div(cashback.phone)
    const file = Img(cashback.file, { width: 120 })
    const buttons = Div()
    const confirm = Div('تایید')
    const reject = Div('رد')
    buttons.append(confirm, reject)
    const base = Div()
    base.append(at, amount, file, phone, email, buttons)

    confirm.el.onclick = async () => {
        await services.cashback.updateStatus(cashback._id, 'confirmed' )
        emitter.emit('cashback-confirmed', cashback)
        base.remove()
    }
    reject.el.onclick = async () => {
        await services.cashback.updateStatus(cashback._id, 'rejected' )
        base.remove()
    }

    at.cssClass({
        color: '#888',
        fontSize: '12px',
    })
    file.cssClass({
        borderRadius: '10px',
        margin: '10px 0',
    })
    phone.cssClass({
        direction: 'ltr',
    })
    buttons.cssClass({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: '10px',
    })
    confirm.cssClass({
        padding: '10px',
        backgroundColor: '#13c680e0',
        borderRadius: '10px',
        cursor: 'pointer',
        color: 'white',
        marginLeft: '10px',
        textAlign: 'center',
        width: '100%',
    })
    reject.cssClass({
        padding: '10px',
        textAlign: 'center',

        backgroundColor: 'crimson',
        color: 'white',
        borderRadius: '10px',
        cursor: 'pointer',
        width: '100%',

    })
    base.cssClass({
        marginBottom: '30px',
        backgroundColor: '#eee',
        borderRadius: '15px',
        textAlign: 'right',
        padding: '15px',
        lineHeight: '22px'
    })

    return base
}